import { createSlice } from "@reduxjs/toolkit";

export const summaryPelanggan = createSlice({
  name: "summaryPelanggan",
  initialState: {
    value: false,
  },
  reducers: {
    setsummaryPelanggan: (state, { payload }) => {
      state.value = payload;
    },
  },
});

export const { setsummaryPelanggan } = summaryPelanggan.actions;
export default summaryPelanggan.reducer;
